import { render, staticRenderFns } from "./LayoutMobile.vue?vue&type=template&id=abf347e8&"
import script from "./LayoutMobile.vue?vue&type=script&lang=js&"
export * from "./LayoutMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports